<app-table
    [translatePrefix]="prefix"
    [items]="items"
    [columns]="columns"
    (deleteCallbackWithEvent)="delete($event)"
    (detailCallback)="open($event)"
>
</app-table>
